import { makeStyles, Spinner } from "@fluentui/react-components";

const useStyles = makeStyles({
    root: {
        minHeight: "100vh",
        padding: "1rem",
    },
    loading_root: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
    },
});

interface LoadingProps {
    text?: string;
}

export const Loading = ({ text = "Loading..." }: LoadingProps) => {
    const styles = useStyles();

    return (
        <div className={styles.loading_root}>
            <Spinner />
            <p>{text}</p>
        </div>
    );
};